import { useEffect, useRef, useState } from "react";
import { FaFacebook, FaLinkedin, FaGithub, FaInstagram } from "react-icons/fa";

const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const quotes = [
  "Not all treasures are meant to be found — this One-piece stays private.",
  "Unless you know a good lawyer.",
  "This repo is private, as this masterpiece deserves mystery.",
  "Unless you find my private repo.",
  "Because the best art isn't always on display.",
  "Unless you are a good hacker.",
  "This masterpiece is my One-piece — and aren't meant for GitHub pirates.",
  "Unless you inspect the code, but it's not easy.",
  "Like the real One-Piece, this repo stays hidden.",
  "Like the One-Piece, it exists… but only I know where.",
  "Don't fork it — you can't. As it's private.",
  "Some art lives in museums, others in private repos.",
  "I could open source this… but it's 50% code, 30% creativity, 20% Sleepless Nights.",
  "If you're reading this, congratulations — you passed the 'attention to detail' test.",
  "If you're reading this, you've explored more than other users do.",
  "If you're reading this, you're exactly the kind of person I'd trust with my private repo (but still no).",
  "If you're reading this, you probably inspected element too.",
  "If you're reading this, you've clicked every button and hovered every pixel. Respect."
]

const Footer = () => {
  const titleRef = useRef(null);
  const getRandomQuote = () => quotes[Math.floor(Math.random() * quotes.length)];

  const [quote, setQuote] = useState(getRandomQuote());
  const [fade, setFade] = useState(false);

  const changeQuote = () => {
    setFade(true);
    setTimeout(() => {
      setQuote(getRandomQuote());
      setFade(false);
    }, 500);
  };

  useEffect(() => {
    const interval = setInterval(changeQuote, 8000);
    return () => clearInterval(interval);
  }, []);

  const handleMouseEnter = () => {
    let iteration = 0;
    const titleElement = titleRef.current;

    if (!titleElement) return;

    const originalText = titleElement.innerText;

    const interval = setInterval(() => {
      titleElement.innerText = originalText
        .split("")
        .map((letter, index) => {
          if (index < iteration) {
            return originalText[index];
          }
          return letters[Math.floor(Math.random() * 26)];
        })
        .join("");

      if (iteration >= originalText.length) {
        clearInterval(interval);
      }
      iteration += 1 / 3;
    }, 30);
  };

  return (
    <footer className="text-white pb-16 px-0 mt-32 font-[Bai Jamjuree]">
      <div className="mx-auto flex flex-col items-center text-center">
        <h2 ref={titleRef} onMouseEnter={handleMouseEnter} className="footerTitle text-2xl font-medium text-[#00fffc]">HeartwareFolio</h2>
        <p className="mt-2 text-gray-400">Powered by <span className="blink-text">Heart</span>, Fueled by <span className="text-xl text-[#00fffc] font-[Doto] font-semibold">Pixel</span></p>

        <div className="flex space-x-6 mt-4">
          <a href="http://linkedin.com/in/ravikiran25052" target="_blank" rel="noopener noreferrer" className="text-[#00fffc] text-2xl hover:text-white transition duration-300">
            <FaLinkedin />
          </a>
          <a href="https://www.facebook.com/profile.php?id=100081346685070" target="_blank" rel="noopener noreferrer" className="text-[#00fffc] text-2xl hover:text-white transition duration-300">
            <FaFacebook />
          </a>
          <a href="https://www.instagram.com/ravikiran_25052/" target="_blank" rel="noopener noreferrer" className="text-[#00fffc] text-2xl hover:text-white transition duration-300">
            <FaInstagram />
          </a>
          <a href="https://github.com/RaviKiran25052" target="_blank" rel="noopener noreferrer" className="text-[#00fffc] text-2xl hover:text-white transition duration-300">
            <FaGithub />
          </a>
        </div>

        <p className="text-gray-500 leading-6 text-sm mt-4 px-8">
          &copy; {new Date().getFullYear()} HeartwareFolio. All rights reserved. <br />
          <span
            title="click me"
            onClick={changeQuote}
            className={`text-[#00fffb7b] cursor-pointer transition-all duration-500 ease-in-out transform ${fade ? 'opacity-0 -translate-y-2' : 'opacity-100 translate-y-0'}`}>
            {quote}
          </span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;